import {useInjex} from '@injex/react-plugin';
import {HistoryReportsManager} from '../../managers/historyReportsManager.mdl';

export default function useHistoryReportsManager(): HistoryReportsManager {
    const [inject] = useInjex();
    return inject<HistoryReportsManager>('historyReportsManager');
}
